<template functional>
    <p>
        <slot>{{props.text}}</slot>
    </p>
</template>

<script>
export default {
    name: 'oc-no-results-found',
    props: {
        text: {
            type: [String, Number],
            default: "No results found!"
        }
    }
}
</script>
